import { faDownload } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack } from "@mui/joy";
import saveAs from "file-saver";
import { memo, useCallback } from "react";
import { EntitiesSearch } from "components/base";
import { type AuditLogRecord } from "./models";

interface MediaDataRoomLogsToolbarProps {
  onSearchChange: (value: string) => void;
  searchValue: string;
  hasData: boolean;
  getLogs: () => AuditLogRecord[];
}

const MediaDataRoomLogsToolbar = memo<MediaDataRoomLogsToolbarProps>(
  ({ onSearchChange, searchValue, hasData, getLogs }) => {
    const handleDownload = useCallback((logs: AuditLogRecord[]) => {
      const file = new File([JSON.stringify(logs, null, 2)], `Audit.json`, {
        type: "application/json;charset=utf-8",
      });
      saveAs(file);
    }, []);
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        rowGap={2}
        width="100%"
      >
        <Stack direction="row" sx={{ width: "280px" }}>
          <EntitiesSearch
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange("")}
            placeholder="Search"
            value={searchValue}
          />
        </Stack>
        {hasData ? (
          <Button
            onClick={() => handleDownload(getLogs())}
            startDecorator={<FontAwesomeIcon icon={faDownload} />}
          >
            Download
          </Button>
        ) : null}
      </Stack>
    );
  }
);
MediaDataRoomLogsToolbar.displayName = "MediaDataRoomLogsToolbar";

export default MediaDataRoomLogsToolbar;
